import moment from "moment";
import PeriodoField from "../../../../components/fields/periodoField/PeriodoField.vue";
import TextField from "../../../../components/fields/textField/TextField.vue";
import { SnackBarModule } from "../../../../modules/SnackBarModule";
import { CalendarioConfigCivilService } from "../../../../services/CalendarioConfigCivilService";

export default {
  name: "ParametrizarCalendarioCivis",

  components: {
    PeriodoField,
    TextField,
  },

  data: () => ({
    form: {},
    porcentagemLimite: null,

    loading: {
      field: false,
      btn: false,
    }
  }),

  mounted() {
    this.setForm();
  },

  methods: {
    async setForm() {
      this.loading.field = true;
      const response = await CalendarioConfigCivilService.getParametrizarCalendario();
      this.form = {
        dataAberturaInicio: response.abertura_calendario_inicio,
        dataAberturaFim: response.abertura_calendario_fim,
        porcentagemLimite: response.limite_bm_ferias,
        janeiro: response.jan,
        fevereiro: response.fev,
        marco: response.mar,
        abril: response.abr,
        maio: response.mai,
        junho: response.jun,
        julho: response.jul,
        agosto: response.ago,
        setembro: response.set,
        outubro: response.out,
        novembro: response.nov,
        dezembro: response.dez
      };
      this.loading.field = false;
    },

    prepareForm() {

      if (this.$refs.form.validate()) {
        const formData = new FormData();
        formData.append("data_inicio", moment(this.form.dataAberturaInicio).format("YYYY-MM-DD"));
        formData.append("data_fim", moment(this.form.dataAberturaFim).format("YYYY-MM-DD"));
        formData.append("limite_bm_ferias", this.form.porcentagemLimite);
        formData.append("jan", moment(this.form.janeiro).format("YYYY-MM-DD"));
        formData.append("fev", moment(this.form.fevereiro).format("YYYY-MM-DD"));
        formData.append("mar", moment(this.form.marco).format("YYYY-MM-DD"));
        formData.append("abr", moment(this.form.abril).format("YYYY-MM-DD"));
        formData.append("mai", moment(this.form.maio).format("YYYY-MM-DD"));
        formData.append("jun", moment(this.form.junho).format("YYYY-MM-DD"));
        formData.append("jul", moment(this.form.julho).format("YYYY-MM-DD"));
        formData.append("ago", moment(this.form.agosto).format("YYYY-MM-DD"));
        formData.append("set", moment(this.form.setembro).format("YYYY-MM-DD"));
        formData.append("out", moment(this.form.outubro).format("YYYY-MM-DD"));
        formData.append("nov", moment(this.form.novembro).format("YYYY-MM-DD"));
        formData.append("dez", moment(this.form.dezembro).format("YYYY-MM-DD"));

        return this.updateForm(formData);
      }
      return SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
    },

    async updateForm(formData) {
      this.loading.btn = true;
      await CalendarioConfigCivilService.putParametrizarCalendario(formData);
      this.loading.btn = false;
      // this.setForm();
    }
  }
};